var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAppointment(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    t: 1686801159820,
    className: "icon",
    viewBox: "0 0 1088 1024",
    xmlns: "http://www.w3.org/2000/svg",
    "p-id": 3855,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 212.5,
    height: 200,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M862.96 749.248h62.528a37.056 37.056 0 0 1 37.504 36.544v1.728a37.056 37.056 0 0 1-37.504 36.544H825.648a37.056 37.056 0 0 1-37.504-36.544v-101.568a36.416 36.416 0 0 1 18.752-31.68 38.4 38.4 0 0 1 37.504 0 36.416 36.416 0 0 1 18.752 31.68v63.36zM832.048 960a205.504 205.504 0 0 0 192-192 205.504 205.504 0 0 0-192-192 205.504 205.504 0 0 0-192 192 205.504 205.504 0 0 0 192 192z m5.888 64A249.6 249.6 0 1 1 1088.048 774.4a249.92 249.92 0 0 1-250.112 249.6zM64.048 384h896V192a65.088 65.088 0 0 0-64-64h-128v128c0 24.576-62.016 22.848-64 0V128H320.048v128c0 20.096-67.968 22.08-64 0V128H128.048a65.088 65.088 0 0 0-64 64v192z m640-320V0h64v64h128a129.472 129.472 0 0 1 129.472 135.808v249.6L64.048 448v384a65.152 65.152 0 0 0 64 64h384v64H128.048a109.248 109.248 0 0 1-128-110.848V199.808A137.472 137.472 0 0 1 137.584 62.4L256.048 64V0h64v64M192.048 576h192c53.696 0 78.528 64 0 64H192.048c-79.424 0-54.272-64 0-64z m0 192h192c52.352 0 36.928 64 0 64H192.048c-36.928 0-52.352-64 0-64z m0 0",
    "p-id": 3856,
    fill: "#ffffff"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppointment);
export default __webpack_public_path__ + "static/media/appointment.89d1fbce.svg";
export { ForwardRef as ReactComponent };